var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{domProps:{"innerHTML":_vm._s(_vm.fundPerformanceContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }